import axios from 'axios';
import { API_URL } from '../config';
import { TicketTemplate } from '../types';

export interface ListTicketTemplatesParams {
  search?: string;
  category?: string;
  user_id?: number;
}

export interface CreateTicketTemplatePayload {
  title: string;
  description: string;
  category?: string | null;
  urgency?: 'ALTA' | 'MEDIA' | 'BAIXA' | null;
  priority?: 'p1' | 'p2' | 'p3' | 'p4' | null;
  requester_id?: number | null;
  assigned_group_id?: number | null;
  workflow_id?: number | null;
}

export const listTicketTemplates = async (
  params: ListTicketTemplatesParams = {}
): Promise<TicketTemplate[]> => {
  const response = await axios.get(`${API_URL}/api/ticket-templates/`, { params });
  return response.data;
};

export const listTicketTemplateCategories = async (userId?: number): Promise<string[]> => {
  const params = userId ? { user_id: userId } : undefined;
  const response = await axios.get(`${API_URL}/api/ticket-templates/categories`, { params });
  return response.data;
};

export const createTicketTemplate = async (
  payload: CreateTicketTemplatePayload
): Promise<TicketTemplate> => {
  const response = await axios.post(`${API_URL}/api/ticket-templates/`, payload);
  return response.data;
};

export const deleteTicketTemplate = async (templateId: number): Promise<void> => {
  await axios.delete(`${API_URL}/api/ticket-templates/${templateId}`);
};
